'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/tickets/Flat.tsx
import { jsx } from "react/jsx-runtime";
var FlatTicketIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 6.75C2 5.23122 3.23122 4 4.75 4H19.25C20.7688 4 22 5.23122 22 6.75V9.25C22 9.58821 21.7736 9.88458 21.4473 9.97357C19.4342 10.5226 19.4342 13.4774 21.4473 14.0264C21.7736 14.1154 22 14.4118 22 14.75V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V14.75C2 14.4118 2.22637 14.1154 2.55266 14.0264C4.56578 13.4774 4.56578 10.5226 2.55266 9.97357C2.22637 9.88458 2 9.58821 2 9.25V6.75ZM4.75 5.5C4.05964 5.5 3.5 6.05964 3.5 6.75V8.72312C6.25 9.95184 6.25 14.0482 3.5 15.2769V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H19.25C19.9404 18.5 20.5 17.9404 20.5 17.25V15.2769C17.75 14.0482 17.75 9.95184 20.5 8.72312V6.75C20.5 6.05964 19.9404 5.5 19.25 5.5H4.75ZM15.25 7C15.6642 7 16 7.33579 16 7.75V8.25C16 8.66421 15.6642 9 15.25 9C14.8358 9 14.5 8.66421 14.5 8.25V7.75C14.5 7.33579 14.8358 7 15.25 7ZM15.25 11C15.6642 11 16 11.3358 16 11.75V12.25C16 12.6642 15.6642 13 15.25 13C14.8358 13 14.5 12.6642 14.5 12.25V11.75C14.5 11.3358 14.8358 11 15.25 11ZM15.25 15C15.6642 15 16 15.3358 16 15.75V16.25C16 16.6642 15.6642 17 15.25 17C14.8358 17 14.5 16.6642 14.5 16.25V15.75C14.5 15.3358 14.8358 15 15.25 15Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/tickets/TicketIcon.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var TicketIcon = ({ className = "", double = true }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "24",
      height: "21",
      viewBox: "0 0 24 21",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className,
      children: [
        double && /* @__PURE__ */ jsx2(
          "path",
          {
            opacity: "0.3",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.1176 10.928C10.7082 10.5185 9.95358 10.5185 9.54411 10.928L7.6527 12.8194C7.29054 13.1816 7.29054 13.7688 7.6527 14.131L8.05098 14.5292C8.4072 14.8855 9.04912 14.9007 9.60245 14.8521C10.1611 14.8031 10.7368 14.9924 11.1644 15.42C11.6868 15.9424 11.8535 16.6859 11.6644 17.3494C11.5668 17.6918 11.5924 18.0707 11.8627 18.341L12.4535 18.9318C12.8157 19.294 13.4029 19.294 13.765 18.9318L15.8968 16.8C16.2134 16.4834 16.2134 16.0234 15.8968 15.7068L15.332 15.1419C15.0251 14.835 15.0251 14.3375 15.332 14.0306C15.6388 13.7237 16.1364 13.7237 16.4433 14.0306L16.768 14.3553C17.1775 14.7648 17.932 14.7648 18.3415 14.3553L23.0112 9.68556C23.3733 9.32339 23.3733 8.7362 23.0112 8.37403L22.6128 7.97567C22.2566 7.61942 21.6146 7.60421 21.0613 7.65278C20.5026 7.70182 19.9269 7.51253 19.4993 7.08493C18.9769 6.56247 18.8102 5.81895 18.9993 5.15545C19.0969 4.81305 19.0713 4.4341 18.801 4.16377L18.2104 3.57316C17.8482 3.21099 17.261 3.21099 16.8988 3.57316L11.9888 8.48328C11.6722 8.79989 11.6722 9.25984 11.9888 9.57645L12.5535 10.1412C12.8604 10.448 12.8604 10.9456 12.5535 11.2525C12.2466 11.5594 11.749 11.5594 11.4421 11.2525L11.1176 10.928ZM13.1092 12.9196C12.8023 12.6127 12.8023 12.1151 13.1092 11.8082C13.4161 11.5013 13.9136 11.5013 14.2205 11.8082L14.7762 12.3639C15.0831 12.6708 15.0831 13.1683 14.7762 13.4752C14.4693 13.7821 13.9717 13.7821 13.6648 13.4752L13.1092 12.9196Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx2(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.6629 9.30772L0.984736 11.9859C0.622568 12.3481 0.622568 12.9353 0.984736 13.2975L2.0237 14.3364C2.78649 13.8311 3.82433 13.9144 4.49639 14.5865C5.16845 15.2586 5.25181 16.2964 4.74645 17.0592L5.78554 18.0983C6.14771 18.4605 6.7349 18.4605 7.09707 18.0983L9.77545 15.4199L8.66399 14.3084C8.3571 14.0015 8.3571 13.504 8.66399 13.1971C8.97087 12.8902 9.46844 12.8902 9.77532 13.1971L10.8868 14.3086L16.3432 8.85207C16.7054 8.4899 16.7054 7.9027 16.3432 7.54053L15.3041 6.50144C14.5413 7.00686 13.5034 6.92353 12.8314 6.25143C12.1593 5.57934 12.0759 4.54144 12.5814 3.77863L11.5424 2.73967C11.1802 2.37749 10.593 2.37749 10.2309 2.73967L4.77424 8.19637L5.88551 9.30766C6.1924 9.61455 6.1924 10.1121 5.88551 10.419C5.57863 10.7259 5.08107 10.7259 4.77418 10.419L3.6629 9.30772ZM6.44121 12.0861C6.13432 11.7792 6.13432 11.2816 6.44121 10.9747C6.74809 10.6678 7.24566 10.6678 7.55254 10.9747L8.10821 11.5304C8.41509 11.8373 8.41509 12.3348 8.10821 12.6417C7.80132 12.9486 7.30376 12.9486 6.99687 12.6417L6.44121 12.0861Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
};

// src/tickets/TicketWarning.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var TicketWarningIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsxs2(
    "svg",
    {
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx3(
          "path",
          {
            d: "M3.7972 46.3752C2.25715 47.9152 2.26179 50.4263 3.80715 51.9717L10.2898 58.4543C12.0423 56.9446 14.4334 56.365 16.6541 56.9408C19.7964 57.7693 22.0412 59.8942 22.818 62.774C23.4636 65.1614 22.9523 67.7059 21.4858 69.6504L28.0283 76.1929C29.5737 77.7382 32.0848 77.7429 33.6248 76.2028L67.0635 42.7642L37.2358 12.9365L3.7972 46.3752ZM46.0559 33.9524C51.264 39.1605 51.2602 47.6382 46.0467 52.8517C40.8341 58.0643 32.3562 58.0682 27.1482 52.8601C21.9348 47.6467 21.9347 39.1651 27.1474 33.9524C32.3608 28.739 40.8424 28.7389 46.0559 33.9524Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx3(
          "path",
          {
            d: "M36.6039 54.5741C42.7579 54.5741 47.764 49.5627 47.764 43.4022C47.764 37.2417 42.7579 32.2292 36.6039 32.2292C30.4434 32.2292 25.4309 37.2417 25.4309 43.4022C25.4309 49.5627 30.4434 54.5741 36.6039 54.5741ZM35.4987 38.7277C35.4987 38.1205 35.9901 37.6291 36.5973 37.6291C37.2045 37.6291 37.6959 38.1205 37.6959 38.7277V43.4966C37.6959 44.1038 37.2045 44.5952 36.5973 44.5952C35.9901 44.5952 35.4987 44.1038 35.4987 43.4966V38.7277ZM35.4987 47.5758C35.4987 46.9686 35.9901 46.4772 36.5973 46.4772C37.2045 46.4772 37.6959 46.9686 37.6959 47.5758V48.0769C37.6959 48.6841 37.2045 49.1755 36.5973 49.1755C35.9901 49.1755 35.4987 48.6841 35.4987 48.0769V47.5758Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx3(
          "path",
          {
            d: "M76.193 28.0282L69.6519 21.4871C66.5377 23.8412 62.073 23.6007 59.2358 20.7634C56.3985 17.9262 56.158 13.4616 58.512 10.3472L51.9717 3.8069C50.4263 2.26154 47.9152 2.2569 46.3744 3.79773L38.7895 11.3827L68.617 41.2102L76.2019 33.6253C77.7428 32.0847 77.7383 29.5735 76.193 28.0282Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
};

export {
  FlatTicketIcon,
  TicketIcon,
  TicketWarningIcon
};
//# sourceMappingURL=chunk-HECNVNKS.mjs.map